export const ACTIVITY_LOG_EXTRACT_DOWNLOAD = 'ACTIVITY_LOG_EXTRACT_DOWNLOAD'
export const ACTIVITY_LOG_EXTRACT_DOWNLOAD_RESPONSE = 'ACTIVITY_LOG_EXTRACT_DOWNLOAD_RESPONSE'

export const activityLogExtractDownload = (data) => {
    return {
        type: ACTIVITY_LOG_EXTRACT_DOWNLOAD,
        data
    }
}

export const activityLogExtractDownloadResponse = (data) => {
    return {
        type : ACTIVITY_LOG_EXTRACT_DOWNLOAD_RESPONSE,
        data
    }
}